import Model from "@/lib/model/model";
import request from "@/lib/request/request";
export class Ver extends Model {
  companyId = 0;
  examType = ""; //test aiworker走普工  normal
  reportVersion = 0; //1模拟考 或其他
  openAiComment = 0; //0旧版 AIbuilder版  1新ai解析版
  reportPath = ""; //最新 直接用的报告路径
  defPath = "";
  scoreVersion = 0; // 打分页 0-旧版 1-新版
}

export class BlankQuestionAnswer extends Model {
  words = ""; // 答案 多个答案用|||分割 禁止空
  score = 0; // 每空单独计分分支下的每空分数 所有空分数总和必须为100
}

export class BlankQuestionConfig extends Model {
  ignoreBlank = 1; // 是否忽略答案首尾空白

  scoreType = 1; //1 全对满分否则0分  2 按答对比例得分 3 每空单独计分
  strictOrder = 1; //是否顺序严格
  desc = "";
  answerList: BlankQuestionAnswer[] = [new BlankQuestionAnswer()];
}

export class Option extends Model {
  content = ""; //内容
  isRight = 0;
  key = "";
  keyScore = 0;
}
export class WorkLocation extends Model {
  locationLat = "";
  locationLng = "";
  locationName = "";
}
export class TimeToScoreRule extends Model {
  score = 0; //分值
  timeRange: number[] = [0]; //时间区间(分)
}
export class ChoiceQuestion extends Model {
  desc = "";
  key = "";
  score = 0;
}
export class LocationQuestionConfig extends Model {
  workLocationList: WorkLocation[] = [new WorkLocation()]; //上班地点
  useDrivingTime = 0; // 是否使用驾车时间 否则采用公交时间 1驾车
  timeToScoreRules: TimeToScoreRule[] = [new TimeToScoreRule()]; //参考答案 通勤时间与分值
  choiceQuestionList: ChoiceQuestion[] = [new ChoiceQuestion()]; //单选答案 看待时间态度
}
export class PicOption extends Model {
  content = "";
  isRight = 0;
  key = "";
  keyScore = 0;
}
export class ColorQuestion extends Model {
  colorQuestionId = 0;
  imgUrl = "";
  optionList: PicOption[] = [new PicOption()];
}

export class ColorQuestionConfig extends Model {
  count = 0;
  colorQuestionList: ColorQuestion[] = [new ColorQuestion()];
}
export class XLL extends Model {
  desc = "";
  optionList: Option[] = [new Option()]; //单多选-选项
}
export class XLconfig extends Model {
  count = 0;
  psychologicalQuestionList: XLL[] = [new XLL()];
}
export class Relist extends Model {
  key = "";
  value = "";
}
export class DescTemplateConfig extends Model {
  defaultStr = "";
  keyType = "";
  originStr = "";
  paramName = "";
  replaceStrList: Relist[] = [new Relist()];
}
export class Question extends Model {
  descVideo1 = ""; //面试须知视频
  questionId = 0;
  selected = false;
  type = 0; //题目类型
  companyIndex = 0;
  desc = "";
  descTextOnly = "";
  typeName = "";
  score = 0; //分值
  showScore = ""; //解决新建题目 分数置空展示
  remark = "";
  difficultLevel = 0;
  optionList: Option[] = [new Option()]; //单多选-选项
  blankQuestionConfig = new BlankQuestionConfig(); //填空题相关
  aiDimensionList: string[] = [""]; //AI考察维度
  aiDimensionKeyList: string[] = [""]; //ai维度 key
  preparationTime = -1; //准备时长
  answerTime = -1; //答题时长
  locationQuestionConfig = new LocationQuestionConfig(); //通勤信息
  colorQuestionConfig = new ColorQuestionConfig(); //色盲题
  isTestResultQuestion = false; //是否测评类型 是则不计在题目总数
  psychologicalQuestionConfig = new XLconfig(); //心理题型
  descTemplateConfig: DescTemplateConfig[] = [new DescTemplateConfig()];
  scoreRuleStatus = 0; //评分规则 0无 10AI 20已设评分 30未设置
  referenceAnswer = ""; //参考答案
  referenceAnswerTextOnly = "";
  appendDesc = ""; //阅读材料
  audioDescUrl = ""; //音频材料
}

export class QuestionObject extends Model {
  list: Question[] = [new Question()];
  count = 0;
  //获取题库试题List
  static get(params: any, url = "aiExam/question/list") {
    return request.post(url, params).then(resp => {
      //此处assign是model里封装的方法 不是es6的assign它把model里定义的属性从接口中对应地取出来，并且检查了属性的类型，同时格式化刷了一遍，接口源数据存在_resp中
      const qo = new QuestionObject(resp).assign(resp.data.data);
      qo.list.forEach(question => {
        switch (question.type) {
          case 1:
            question.typeName = "单选题";
            break;
          case 2:
            question.typeName = "多选题";
            break;
          case 5:
            question.typeName = "填空题";
            break;
          case 6:
            question.typeName = "视频问答";
            break;
          case 7:
            question.typeName = "测评单选题";
            break;
        }
        question.showScore = String(question.score);
      });
      return qo;
    });
  }
}

export class QuestionPaper extends Model {
  questionList: Question[] = [new Question()];
  questionNumber = 0;
  scoreAll = 0;

  //获取面试试题
  static get(params: any, url = "aiExam/examQuestions/get") {
    return request.post(url, params).then(resp => {
      const q = new QuestionPaper(resp).assign(resp.data.data);
      return q;
    });
  }
}
